const SDK_URL = '//storage.jd.com/paimai/paimai-utils/paimai-utils-1.0.6.js';

/**
 * 加载LBS定位所需sdk文件
 * @returns
 */
const loadSdkScript = () => {
    return new Promise((resolve) => {
        if (window.PaimaiUtils) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.crossorigin = 'anonymous';
        script.onload = function() {
            console.log('加载js成功');
            resolve();
        };
        script.onerror = function() {
            console.log('加载js失败1');
            resolve();
        };
        script.src = SDK_URL;
        document.body.appendChild(script);
    });
};


// 手动唤起弹窗
const manualRequestLocationPermissionForWeb = (businessId) => {
    return new Promise(async(resolve, reject) => {
        await loadSdkScript().catch(err => {
            reject(err);
        });
        const loadSuccess = (window.PaimaiUtils && window.PaimaiUtils.LBS) ? window.PaimaiUtils.LBS.manualReqLocPermWithScene : null;
        if (loadSuccess) {
            const data = await window.PaimaiUtils.LBS.manualReqLocPermWithScene(businessId).catch((err) => {
                reject(err);
            });
            resolve(data);
        }
        reject(new Error('加载js失败'));
    });
};

export {
    manualRequestLocationPermissionForWeb
};
